var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon-svg",attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24"}},[_c(_vm.icon,{key:_vm.name,tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }